import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { PropTypes as PropTypes$1 } from '@panneau/core';
import Button from '@panneau/element-button';
import Label from '@panneau/element-label';
import Link from '@panneau/element-link';

var _excluded = ["label", "className"];
var propTypes = {
  href: PropTypes.string,
  header: PropTypes.node,
  image: PropTypes.node,
  imageAlt: PropTypes.string,
  imageOverlay: PropTypes.bool,
  beforeBody: PropTypes.node,
  title: PropTypes$1.label,
  subtitle: PropTypes$1.label,
  children: PropTypes.node,
  afterBody: PropTypes.node,
  links: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes$1.label,
    href: PropTypes.string
  })),
  linksInSameBody: PropTypes.bool,
  footer: PropTypes.node,
  theme: PropTypes.oneOf([null, 'dark', 'primary', 'light']),
  className: PropTypes.string,
  imageClassName: PropTypes.string,
  headerClassName: PropTypes.string,
  titleClassName: PropTypes.string,
  subtitleClassName: PropTypes.string,
  bodyClassName: PropTypes.string,
  footerClassName: PropTypes.string,
  onClick: PropTypes.func,
  onClickBody: PropTypes.func,
  onClickFooter: PropTypes.func,
  onClose: PropTypes.func,
  onCloseIcon: PropTypes.node
};
var defaultProps = {
  href: null,
  header: null,
  image: null,
  imageAlt: null,
  imageOverlay: false,
  beforeBody: null,
  title: null,
  subtitle: null,
  children: null,
  afterBody: null,
  links: null,
  linksInSameBody: false,
  footer: null,
  theme: null,
  className: null,
  imageClassName: null,
  headerClassName: null,
  titleClassName: null,
  subtitleClassName: null,
  bodyClassName: null,
  footerClassName: null,
  onClick: null,
  onClickBody: null,
  onClickFooter: null,
  onClose: null,
  onCloseIcon: null
};
var Card = function Card(_ref) {
  var href = _ref.href,
    header = _ref.header,
    image = _ref.image,
    imageAlt = _ref.imageAlt,
    imageOverlay = _ref.imageOverlay,
    beforeBody = _ref.beforeBody,
    title = _ref.title,
    subtitle = _ref.subtitle,
    children = _ref.children,
    afterBody = _ref.afterBody,
    links = _ref.links,
    linksInSameBody = _ref.linksInSameBody,
    footer = _ref.footer,
    theme = _ref.theme,
    className = _ref.className,
    imageClassName = _ref.imageClassName,
    headerClassName = _ref.headerClassName,
    titleClassName = _ref.titleClassName,
    subtitleClassName = _ref.subtitleClassName,
    bodyClassName = _ref.bodyClassName,
    footerClassName = _ref.footerClassName,
    onClick = _ref.onClick,
    onClickBody = _ref.onClickBody,
    onClickFooter = _ref.onClickFooter,
    onClose = _ref.onClose,
    onCloseIcon = _ref.onCloseIcon;
  var linksElements = (links || []).map(function (_ref2, index) {
    var label = _ref2.label,
      _ref2$className = _ref2.className,
      linkClassName = _ref2$className === void 0 ? null : _ref2$className,
      linkProps = _objectWithoutProperties(_ref2, _excluded);
    return /*#__PURE__*/React.createElement(Link, Object.assign({
      key: "link-".concat(label, "-").concat(index),
      className: classNames(['card-link', _defineProperty({}, linkClassName, linkClassName !== null)])
    }, linkProps), label);
  });
  var bodyInner = title !== null || subtitle !== null || children !== null || links !== null && linksInSameBody ? /*#__PURE__*/React.createElement(React.Fragment, null, title !== null ? /*#__PURE__*/React.createElement("h5", {
    className: classNames(['card-title', 'text-break', _defineProperty({}, titleClassName, titleClassName !== null)])
  }, /*#__PURE__*/React.createElement(Label, null, title)) : null, subtitle !== null ? /*#__PURE__*/React.createElement("h6", {
    className: classNames(['card-subtitle', _defineProperty({}, subtitleClassName, subtitleClassName !== null)])
  }, /*#__PURE__*/React.createElement(Label, null, subtitle)) : null, children, links !== null && linksInSameBody ? /*#__PURE__*/React.createElement("div", {
    className: "d-flex"
  }, linksElements) : null) : null;
  var closeButton = /*#__PURE__*/React.createElement(Button, {
    type: "button",
    size: "sm",
    theme: "warning",
    onClick: onClose
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: onCloseIcon || faTimes
  }));
  var cardInner = /*#__PURE__*/React.createElement(React.Fragment, null, header !== null ? /*#__PURE__*/React.createElement("div", {
    className: classNames(['card-header', _defineProperty({}, headerClassName, headerClassName !== null)])
  }, /*#__PURE__*/React.createElement(Label, null, header)) : null, typeof image === 'string' ? /*#__PURE__*/React.createElement("img", {
    src: image,
    alt: imageAlt,
    className: classNames(['card-img-top', _defineProperty({}, imageClassName, imageClassName !== null)])
  }) : image, beforeBody, bodyInner !== null ? /*#__PURE__*/React.createElement("div", {
    className: "position-relative"
  }, onClose !== null ? /*#__PURE__*/React.createElement("div", {
    className: "d-inline-block position-absolute end-0 p-2"
  }, closeButton) : null, onClickBody !== null ? /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: classNames(_defineProperty({
      'card-body': !imageOverlay,
      'card-img-overlay': imageOverlay
    }, bodyClassName, bodyClassName !== null)),
    onClick: onClickBody
  }, bodyInner) : /*#__PURE__*/React.createElement("div", {
    className: classNames(_defineProperty({
      'card-body': !imageOverlay,
      'card-img-overlay': imageOverlay
    }, bodyClassName, bodyClassName !== null))
  }, bodyInner)) : null, afterBody, links !== null && !linksInSameBody ? /*#__PURE__*/React.createElement("div", {
    className: "card-body"
  }, linksElements) : null, footer !== null ? onClickFooter !== null ? /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: classNames(['card-footer', _defineProperty({}, footerClassName, footerClassName !== null)]),
    onClick: onClickFooter
  }, /*#__PURE__*/React.createElement(Label, null, footer)) : /*#__PURE__*/React.createElement("div", {
    className: classNames(['card-footer', _defineProperty({}, footerClassName, footerClassName !== null)])
  }, /*#__PURE__*/React.createElement(Label, null, footer)) : null);
  var cardClassName = classNames(['card', _defineProperty(_defineProperty({}, "bg-".concat(theme), !imageOverlay && theme !== 'dark'), className, className !== null)]);
  if (href !== null) {
    return /*#__PURE__*/React.createElement(Link, {
      href: href,
      className: cardClassName
    }, cardInner);
  }
  if (onClick !== null) {
    return /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: classNames(['p-0', 'text-start', cardClassName]),
      onClick: onClick
    }, cardInner);
  }
  return /*#__PURE__*/React.createElement("div", {
    className: cardClassName
  }, cardInner);
};
Card.propTypes = propTypes;
Card.defaultProps = defaultProps;

export { Card as default };
